import { COMMA, ENTER } from '@angular/cdk/keycodes'
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild,LOCALE_ID, EventEmitter } from '@angular/core'
import { FormControl } from '@angular/forms'
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA
} from '@angular/material'
import { Subject } from 'rxjs'
import { debounceTime, distinctUntilChanged ,startWith,map} from 'rxjs/operators'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { ConsultationService, DialogService, StateService, TiersService, VisiteService, FormulaireService, DossierService, ConnectionService } from '../../../../../services'
import {
	Observable,
	BehaviorSubject,	
} from "rxjs";
import {
    FormDialogFormulaireWithSFComponent
} from "../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component";
import { DatePipe, formatDate } from '@angular/common'
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';

import * as moment from 'moment';

import { CreateConsultationDialogComponent } from "../create-consultation-dialog/create-consultation-dialog.component"
import { ConfirmComponent } from '../../../layout/dialogs/confirm-dialog/confirm.component'

const KEY = 'visite-actions-dialog'



@Component({
	selector: 'atyl-visite-actions-dialog',
	templateUrl: './visite-actions-dialog.component.html',
	styleUrls: ['./visite-actions-dialog.component.scss'],
	providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
@Stringable({
	path: 'views/partials/content/actions/visite-actions-dialog',
	key: KEY
})
export class VisiteActionsDialog extends BaseDialogComponent implements OnInit {
	dateFilter: any=(d: any): boolean => {

       

        const day = d.day();
      //console.log("dateFilter",d,day);

        /* Prevent Saturday and Sunday for select. */

        

        /* Prevent Saturday and Sunday for select. */

        return day !== 0 && day !== 6 ;
    }
	loading: boolean = false;
	currentAction: string = '';
	currentDataType: string = '';
	consultation: any = null;
	visiteDateFin: any
	visiteEtat: any
	visiteProfessionels: any
	visiteDomicile: boolean
	visitePontuelle: boolean
	visiteType: string = '';
    fullname: any
	disabledDateDeFin: boolean = true;
	etatList: any[] = [];

	subscribtions: any[] = [];

	// profesionels search variables
	selectable: boolean = true;
	removable: boolean = true;
	separatorKeysCodes: number[] = [ENTER, COMMA];
	proCtrl = new FormControl();
	accompagnantCtrl = new FormControl();
	locationFormControl = new FormControl('', []);
	
	consultFormControl = new FormControl('', []);
	_defaultConsultValue:any;
	consultOptions: Observable<any[]>;
	
	tiersCtrl = new FormControl();
	selectedMember: any
	searchTerm: string
	updateSearchTerm = new Subject<string>();
	searchDisabled: boolean = true;
	tiersSearchList: any[] = [];
	selectedTiers: any[] = [];
	consultationsList: any[] = [];
	selectedConsultation: any

	tiersList: any = [];
	tiersEnfant:any;
	tiersUsager:any;
    tiersLabelEnfant:string="";
    tiersLabelUsager:string="";
	nbTiers:any;

	formulairesList: any[] = [];
	selectedFormulaires: any = null;

	noVisitesAllowed: boolean = false;

	accompagnantsList: any[] = [];
	selectedAccompagnants: any[] = [];
	searchDisabeldAccompagnant: boolean = false;
	timepickerColor: any;

    /** 
    * CONSULTATION 
    */
    consultationTypeList: any[] = [];
    loadingConsulationType: boolean= true;
    typeInput: any = '';
	typeFilterInput: any ='';
	
    typeGroupe: any = '';
    dateInput: any = new Date();
    invalidDate = false;
    consultationGroup = [];
    consultationLocation = [];
    towns:any[]=[];
    townOptions: Observable<any[]>;
    locationInput: any
	/**
	 * Interventions
	 */
	intervention: any
	
	/**
     * Instruction
     */
    instruction: any

	titre:any;
	comment:any;

    errors:any =[]
    errorMessage:string ="";


	toLoadConsultion:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(true);
	toLoadConsultionSlider:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
    toLoadManyVisitor:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
	toLoadDate:BehaviorSubject<Date>=new BehaviorSubject<Date>(new Date());
	toLoaProfesionnel:BehaviorSubject<number[]>=new BehaviorSubject<number[]>([]);
	
	drawerRightIsOpen: boolean = false;
    drawerLeftIsOpen: boolean = false;
    donnee: string;
    getTiersSelected = [];
    getTiersWithRelations = [];
	getTiersWithRelationsID = [];

    setTiersSelected = [];

    visiteEditable: boolean= true;
    consultationListInPresences: any[] = [];
	@StringableValues(KEY) strings: any
	actions: any[] = [];
	@ViewChild('tiersInput', { read: undefined, static: undefined }) tiersInput: ElementRef<HTMLInputElement>
	@ViewChild('accompagnantInput', { read: undefined, static: undefined }) accompagnantInput: ElementRef<HTMLInputElement>
    @ViewChild('tiersListInput', { read: undefined, static: undefined }) tiersListInput: ElementRef<HTMLInputElement>
	valueDebut: any = '08:00';
	valueDebutDefault: any = '08:00';
	valueFin: any = '17:00';
	visiteDateDebut: any = this.valueDebut

    durationDefaultInput:number=20;
	durationInput:number=this.durationDefaultInput;
	
	tiersSearchGroupList:any[]=[];
	
	isModify:boolean=false;
	isModifyButton:boolean=true;
	
	orderContultation:string="ASC";
	
	_getTiersWithRelationsDossierIDIndex:any={};
	
    columns= [
        {
            "id": "selectable",
            "visible": true,
            "defaultSort": null
        },
        {
            "id": "NOM",
            "label": "Nom",
            "visible": true,
            "sortable": true,
			"defaultSort": null
			
        },
        {
            "id": "PRENOM",
            "label": "Prenom",
            "visible": true,
            "sortable": true,
            "defaultSort": null
        },
        {
            "id": "born",
            "label": "Date de Naissance",
            "visible": true,
            "sortable": true,
			"defaultSort": "DESC"
        },
        {
            "id": "commune",
            "label": "Commune",
            "visible": true,
            "sortable": true,
            "defaultSort": null
        },
        {
            "id": "typeConsultation",
            "label": "Type de tiers",
            "visible": true,
            "sortable": true,
            "defaultSort": null
        },
		{
            "id": "lastRdv",
            "label": "Dernier(s) rendez-vous",
            "visible": true,
            "sortable": true,
            "defaultSort": null
	 	},
		{
			"id": "formulaires",
			"label": "Formulaire(s)",
			"visible": true,
			"sortable": false,
			"defaultSort": null
		}
    ];

    PaginationInstruction: number = 6;
    lengthInstruCount: number = 0;
    currentPageInstruction: number = 0;
    sortInstruction: any= {
		"id":"born",
		"direction":"DESC"
	};
    theSelected: any;
    verifChecked = []
    inited = new EventEmitter<any>();

    listTiersType:any[]=[];
    
    //rdv domicile
    listDomiciles: any[]=[];
    selectedDomicile: any;
    modeEdit: boolean = false;

    user: any

   loadingConsult:boolean=false;
   filterListConsult:boolean=false;
   dateBeginInput:moment.Moment=moment();
   dateEndInput:moment.Moment=moment().add(3, 'months');

   timeSlots: any[] = [];
   consultModif: Subject<any> = new Subject<any>();
   visiteChangeDebounce = new Subject<any>();
   
   old_visit:any;
   visite:any;
   restriction_type:any[]=[];
   
   loadingTiersRelation:boolean=false;
   
   dialogContainer:any;
	constructor(
		changeDetectorRef: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<VisiteActionsDialog>,
		public dialog: MatDialog,
		private stateService: StateService,
		private visiteService: VisiteService,
		private tiersServices: TiersService,
        private connectionService: ConnectionService,
		private consultationService: ConsultationService,
		dialogService: DialogService,
		private formulaireService: FormulaireService,
        private dossierService: DossierService,
		private datePipe: DatePipe
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
		console.log("visit init",this.data,this.intervention);
		this.tiersCtrl.disable({onlySelf:true});
		
		
		if (this.data) {
			
			
			if (this.data.instruction) {
			            this.instruction = this.data.instruction
						
						if (this.instruction.type!=undefined&& this.instruction.type.consultations!=undefined)
							this.restriction_type= this.instruction.type.consultations
						
			            console.log('instruction visite', this.instruction)
			  }
			
			
			if(this.data.old_visit){
			  this.old_visit=this.data.old_visit;
			  if ( this.old_visit.consultation!=undefined) {
				
					if (this.old_visit.consultation.ponctuel!=undefined 
						&& this.old_visit.consultation.ponctuel)
							this.visiteType='ponctuel';
					
					if (this.old_visit.consultation.domicile!=undefined 
								&& this.old_visit.consultation.domicile)
							this.visiteType='domicile';
				
					this.typeFilterInput=this.old_visit.consultation.type;			
					if (this.visiteType!='') {	
						
					
						this.typeInput = this.old_visit.consultation.type;
						
						if (this.visiteType=='ponctuel')
								this.changeTypeGroup(this.typeInput);		
						
						this.getFormulairesList(this.old_visit.consultation);
						//this.loadConsultationType();
					}
					console.log("OLD VISIT",this.old_visit,this.visiteType,this.typeInput);
			  }
					
			  
			  
			}
			this.currentAction = this.data.action
			this.currentDataType = this.data.dataType
			if(this.data.visite){
				if(this.data.visite.titre){
					this.titre = this.data.visite.titre;
				}
				if(this.data.visite.commentaire){
					this.comment = this.data.visite.commentaire;
				}
                if(this.data.visite.consultation){
                    this.modeEdit = true;
                    this.typeInput = this.data.visite.consultation.type;
                    if(this.data.visite.consultation.domicile){
                        this.visiteType='domicile';
                    }
                }
				this.isModify=true;
				this.visite=this.data.visite;
				console.log("VisiteActionsDialog visit",this.visite, this.visiteType)
				
			}
           
            if(this.data.dateF && this.data.startTimeInput){
                this.valueDebut = this.data.startTimeInput;
                this.donnee = this.data.dateF;
            }

            if(this.data.visiteEditable != undefined){
                this.visiteEditable = this.data.visiteEditable;
            }
		}


		this.loadConsultationType();
		
        if(this.data.lots != undefined){
            this.data.lots.forEach(dossier => {
                dossier.id = dossier.ID;
                dossier.typeConsultation = dossier.type;
                dossier.born =dossier.DATENAISSANCE ? this.formaterDate(dossier.DATENAISSANCE) : '<div class="d-none">/div>';
                if(dossier.adresses.PRINCIPALE){
                    dossier.commune = dossier.adresses.PRINCIPALE.town;
                }else{
                    dossier.commune = "";
                }
				dossier.lastRdv=this._getLastRdv(dossier);
                dossier.checked = true;
				this.getTiersSelected.push(dossier);
				this.setTiersSelected.push(dossier);
				this._addDossierTiersSelection(dossier);
				//this.getTiersWithRelations.push(dossier);
				this.relationsTiers(dossier);
            });
            
        }

        if(this.data.dossier!= undefined){
            if(this.data.dossier.tiers != undefined){
                //console.log("ngOnInit whithData selectedConsultation:", this.selectedConsultation, "\ngetTiersSelected:",this.getTiersSelected);
                
                this.data.dossier.tiers.id = this.data.dossier.tiers.ID;
                this.data.dossier.tiers.typeConsultation = this.data.dossier.tiers.type;
                this.data.dossier.tiers.born =this.data.dossier.tiers.DATENAISSANCE ?   this.formaterDate(this.data.dossier.tiers.DATENAISSANCE) : '<div class="d-none">/div>';
                if(this.data.dossier.tiers.adresses.PRINCIPALE){
                    this.data.dossier.tiers.commune = this.data.dossier.tiers.adresses.PRINCIPALE.town;
                }else{
                    this.data.dossier.tiers.commune = "";
                }
				this.data.dossier.tiers.checked = true;
				this.getTiersSelected.push(this.data.dossier.tiers);
				this.setTiersSelected.push(this.data.dossier.tiers);
				this._addDossierTiersSelection(this.data.dossier.tiers);
			//	this.getTiersWithRelations.push(this.data.dossier.tiers);
				this.relationsTiers(this.data.dossier.tiers);
            }
        }
		/*let now:any=new Date();
		let hours = Number.parseInt(this.valueDebut.split(':')[0], 10)
        let minutes = Number.parseInt(this.valueDebut.split(':')[1], 10)
        now.setHours(hours)
        now.setMinutes(minutes)
		this.visiteDateDebut = now
		
		 hours = Number.parseInt(this.valueFin.split(':')[0], 10)
        minutes = Number.parseInt(this.valueFin.split(':')[1], 10)
        now.setHours(hours)
        now.setMinutes(minutes)
        this.visiteDateFin = now
		*/
		
		this.visiteDateDebut=this.valueDebut;
		
		let dt:Date=new Date();
		let hours = Number.parseInt(this.visiteDateDebut.split(':')[0], 10)
	    let minutes = Number.parseInt(this.visiteDateDebut.split(':')[1], 10)
		dt.setHours(hours);
		dt.setMinutes(minutes);
		
		//let dt:Date=this.datePlusTime(this.visiteDateDebut);
		//console.log('fin0',this.visiteDateDebut,dt,this.durationInput);
		dt = this.dateAdd(dt,'minute',this.durationInput);
		this.valueFin=dt.getHours()+":"+dt.getMinutes();	
	
		this.visiteDateFin=this.valueFin;
		this.stateService.consultation.subscribe((cons: any) => {
        //console.log("this.data:",this.data,"\ncons:",cons,"\nintervention:",this.intervention);
			if (cons && (this.data.page != undefined && (this.data.page.key == "DOSSIERCONSULATION" || (this.data.page == "bilan seance"|| this.data.page.key == "BILAN" || this.data.page.key == "NOMADE_CONSULTATION")))) {
				this.consultation = cons
				console.log("consultation open",this.consultation);

				if (this.consultation.etat!=undefined 
					&& this.consultation.etat.etat!=undefined 
					 && !this.consultation.etat.etat					
					&& !this.isModify
				 )
					this.isModifyButton=false;
				
				this.tiersCtrl.enable({onlySelf:true})

				if(this.consultation.type.tiers.length > 0){
					this.nbTiers = 0;
					this.tiersLabelUsager="";
					this.tiersLabelEnfant="";
					
                    this.fullname = this.data.visite?this.data.visite.tiers.NOM+" "+this.data.visite.tiers.PRENOM+" - "+formatDate(this.data.visite.tiers.DATENAISSANCE, 'dd/MM/yyyy', 'fr'):"";
					this.consultation.type.tiers.forEach(tier => {
						//console.log("VisiteActionsDialog init label",tier)
						if(tier.code == 'ENFANT'){
							this.tiersEnfant = true;
							this.nbTiers = this.nbTiers + 1
							this.tiersLabelEnfant=tier.libelle;
						} else if(tier.code == 'USAGER'){
							this.tiersUsager = true;
							this.nbTiers = this.nbTiers + 1
							this.tiersLabelUsager=tier.libelle;
						}
					});
				}
				this.selectedConsultation=this.consultation;
              //  console.log('selectedConsultation:',this.selectedConsultation,'\nconsultation:',this.consultation);
				if (this.selectedConsultation.visitesObj!=undefined) {
	               
					 this.selectedConsultation.visitesObj.forEach(visite => {
	                    if(visite.groupe!= undefined &&  visite.groupe !== null){
	                        this.typeGroupe = visite.groupe.ID; 
	
	                    }
	                });
					
				}	
                this._getConsultationTypeGroupe(this.selectedConsultation.type.ID);
                
                // this.valueDebut = this.valueDates(this.consultation.date_debut);
                // this.valueFin = this.valueDates(this.consultation.date_fin);
				
				/*if (!this.data.edit && (this.consultation.domicile || this.consultation.ponctuel)) {
					this.noVisitesAllowed = true
				} else {
					this.noVisitesAllowed = false
				}*/
				if (this.selectedConsultation.professionels!=undefined) {
					this.visiteProfessionels = this.selectedConsultation.professionels ? this.idFiy(this.selectedConsultation.professionels) : []
					this.toLoaProfesionnel.next(this.visiteProfessionels);
				}
				this.getFormulairesList(this.consultation)
				//console.log("___this.consultation",this.consultation)
				//this.timeSlots = this.consultation.visites_plage.plages;
				this.consultationService.getConsultationPlage(this.consultation.ID).subscribe((res)=>{
					this.timeSlots = res.result.plages;
				})
				this.updateSliderObjEdit("consultationSelect");
			} else {
				this.initProfessionelsSearch()
				
			}
			if (this.consultation && this.consultation.professionels.length === 0) {
				this.initProfessionelsSearch()
			}
		})
		
		if (this.data.visite) {
			this.currentAction = 'edit';
            if(this.selectedConsultation == undefined){
                this.selectedConsultation =this.data.visite.consultation;
                this._getConsultationTypeGroupe(this.typeInput.ID)
				if (this.selectedConsultation.groupe!=undefined)
                		this.typeGroupe = this.selectedConsultation.groupe.ID; 
                this.selectedConsultation.professionels = this.data.visite.professionels.object;
            }
			this.prefillVisite(this.data.visite)
		} else
		 	this.initConsultationsList()
		
		if (this.data.intervention) {
			this.intervention = this.data.intervention
		//	console.log('intervention visite', this.intervention)
		}
		
		
		
		this.initAccompagnantsSearch()

		this.initTiersSearch();
		
		this.generateVisiteEtatList()

		
		this.visiteChangeDebounce.pipe(
			debounceTime(1500) 
		).subscribe((event) => {
			this.updateSliderObjEdit(event);
		});
        //console.log("visiteType:",this.visiteType,"\nconsultation:",this.consultation,"\ntaille consultationList:",this.consultationsList);
	}
	
	_addDossierTiersSelection(dossier:any) {
		
		if (dossier.ID!=undefined 
			 && this.getTiersWithRelationsID[dossier.ID]==undefined) {
				this.getTiersWithRelationsID[dossier.ID]=dossier;
				if (!dossier.PRENOM)
					dossier.PRENOM="";
				let selection:any[]=JSON.parse(JSON.stringify(this.getTiersWithRelations));
				
//				console.log("_addDossierTiersSelection",dossier)
			//	this.getTiersWithRelations.push(dossier);
				selection.push(dossier);
				selection=this.trierTableau(selection);
				this.getTiersWithRelations=JSON.parse(JSON.stringify(selection));
				let ii:number=0;
				this.getTiersWithRelations.forEach((ds:any)=>{
					if (ds.id!=undefined)
						this._getTiersWithRelationsDossierIDIndex[ds.id]=ii;
					ii++;
				});
				//this.changeDetectorRef.detectChanes();
		}
	}
	

	ngAfterViewChecked() {
				
				
			
				// this.dialogContainer = document.querySelector('.cdk-global-overlay-wrapper > .cdk-overlay-pane')
				 this.dialogContainer = document.querySelector('.visit_drawer_container')
				if (this.dialogContainer) {
				//	console.log("ngAfterViewChecked container",this.dialogContainer)
					this.dialogContainer.addEventListener('resize', this.onResized(this));
				}	
		}	
		
		onResized(event: any): void {
			
			//console.log("onResized before",event,this.formHeight);
			//let sizeH:number=(this.isNomade) ? 205 :165;
			
			if (this.dialogContainer) {
				let header:number=205+ 76
				
				let sizeH:number=this.dialogContainer.clientHeight
				let dateC:any= document.querySelector('.week-container-oneday')
				//console.log("ngAfterViewChecked onResized",sizeH,dateC)
				
				if (dateC!=undefined && (sizeH-header)>0)
					dateC.style="height: "+ (sizeH-header) + "px;";
				
				let headerRelation:number=80+190;
				let vsRelation:any= document.querySelector('.table-tiers-relation');
				if (vsRelation!=undefined && (sizeH-headerRelation)>0)
						vsRelation.style="height: "+ (sizeH-headerRelation) + "px;";
				this.dialogContainer.removeEventListener('resize',null);
				
				
			}

			//this.changeDetectorRef.detectChanges()
		}
		
	_getLastRdv(tiers:any) {
		let lastRdv:string="";
		//console.log("_getLastRdv",tiers,tiers.rdvs);
		if (tiers.rdvs!=undefined && Array.isArray(tiers.rdvs) && tiers.rdvs.length>0) {
			let rdv:any=tiers.rdvs[0];
			let strs:string[]=[];
			let dtdeb_fin:any[]=[];
			if (rdv.date_debut!=undefined) 
				dtdeb_fin.push(rdv.date_debut);
			if (rdv.date_fin!=undefined) 
				dtdeb_fin.push(rdv.date_fin);
			if (dtdeb_fin.length>0)
				strs.push('<div class="d-none">'+ dtdeb_fin.join("") +'</div>');
									
			
			if (rdv.consultation!=undefined 
				&& rdv.consultation.type!=undefined 
				 && rdv.consultation.type.libelle!=undefined) 
				 strs.push( rdv.consultation.type.libelle+"<br/>");
			 if (rdv.date_debut!=undefined 
			 				) 
						 strs.push("de "+ formatDate(rdv.date_debut,'dd/MM/yyyy HH:mm','fr'));
			
			 if (rdv.date_fin!=undefined 
			 		 				) 
			 	 strs.push("à "+ formatDate(rdv.date_fin,'HH:mm','fr'));	
			 if (tiers.rdvs.length>1)
			 	strs.push( "(" + tiers.rdvs.length + ")");	
		     lastRdv=strs.join(" ");	 	 
		}
		return lastRdv;
	}
	
	/**
		CONSULTATION BEGIN
	 */
    selectVisiteType(event:any) {
		this.formulairesList = [];
        console.log("selectVisiteType",this.visiteType);
		console.log(this.typeInput)
        if (this.visiteType!=''){
			this.filterListConsult=false;
            this.selectedConsultation=null;
			if(this.typeInput == ''){
				this.tiersEnfant = false;
				this.tiersUsager = false;
			}
            if(this.donnee != undefined && this.donnee){
                var format = (f: any) =>{
                    let jour = f[8]+f[9]; 
                    let mois = f[5]+f[6]; 
                    let annee = f[0]+f[1]+f[2]+f[3];
                   
                    return jour+"/"+mois+"/"+annee;
                };
                let date = new Date( Date.parse(this.donnee));
                if(this.donnee == undefined){
                  //  this.dateInput= new Date()
                }else{
                    this.dateInput = date;
                    this.donnee = format(this.donnee);
                    this.donnee = "";
                }
            }
            if (this.data.startTimeInput!=undefined
             && this.data.startTimeInput)
            	this.valueDebut = this.data.startTimeInput;
            else
            	this.valueDebut =this.valueDebutDefault;
            
		} else if(this.visiteType == "") {
			this.typeInput = null;
			this.tiersEnfant = false;
			this.tiersUsager= false;
			if (this.consultation && this.consultation.date_debut!=undefined)
            	this.valueDebut = this.valueDates(this.consultation.date_debut);
			this.changeDetectorRef.detectChanges();
		}
        //if (this.loadingConsulationType)
            this.loadConsultationType();
    }

    _hasCommonElement(array1, array2) {        
        return array1.some(element => array2.includes(element));
    }

    selectSousType(event: any){
        console.log("selectSousType event:",event,'\ntypeGroupe:',this.typeGroupe);

    }
    
    loadConsultationType() {
        var tabUserProfessions = [];
        var tabConsultationListTypeProfessions = [];
        
        this.tiersServices.getProfessionsString().subscribe((res: JSONRpcResponse) =>{
            if (res) {
                this.user = res.result;
                
                if (this.user && this.user.professions) {
                    this.user.professions.forEach((pro: any) => {
                        if (pro) {
                            tabUserProfessions.push(pro.libelle);
                        }
                    });
                }
            } 

            let _opt = {"visiteType": this.visiteType == "" ?"consultation":this.visiteType};
			if (this.restriction_type.length>0)
				_opt["restriction"]=this.restriction_type;
			else {
					 				
			 				if(this.data.dossier!= undefined){
			 				    if(this.data.dossier.tiers != undefined && this.data.dossier.tiers.type != undefined){
			 						_opt["tiersType"]=this.data.dossier.tiers.type;
			 					}
			 				}
		   }		
            this.consultationTypeList = [];
//			console.log("VisiteActionsDialog loadConsultationType",_opt);
            this.consultationService.getConsultationTypeList(_opt).subscribe((res: JSONRpcResponse) => {
                res.result.forEach(aff => {
                    if(!aff.noDisplay){
                        tabConsultationListTypeProfessions = []
                        aff.professions.forEach(tri => {
                            if(tri)
                                tabConsultationListTypeProfessions.push(tri.libelle)
                        });
                        
                        if(this._hasCommonElement(tabUserProfessions,tabConsultationListTypeProfessions)){
                            this.consultationTypeList.push(aff);
							
							if (this.typeInput!=undefined && this.typeInput.ID==aff.ID) {
									this.typeInput=aff;
									
							}
							if (this.typeFilterInput!=undefined && this.typeFilterInput.ID==aff.ID) {
								this.typeFilterInput=aff;
							}		
                            tabConsultationListTypeProfessions = [];
                        }
                    }
                });

              //  console.log(this.consultationTypeList, 'consultationTypeList',this.typeInput)
                this.loadingConsulationType=false;

                this.changeDetectorRef.detectChanges()
            })

            this.changeDetectorRef.detectChanges()
        });
        this.changeDetectorRef.detectChanges();
    }
    
	_searchTiersProfessional(){
		let _optS:any={location: this.locationInput
								                    };
								if (this.getTiersSelected!=undefined 
									&& this.getTiersSelected.length>0 
									&& this.getTiersSelected[0]!=undefined 
									&& this.getTiersSelected[0].ID!=undefined 
									)
									_optS["tiersId"]=this.getTiersSelected[0].ID;	
						
			this.tiersServices
			                    .getTiersByConsultationType(this.typeInput.ID, _optS)
			                    .subscribe((res: JSONRpcResponse) => {
			                        this.tiersSearchList = res.result
									if(this.currentAction == "create" && this.selectedTiers.length == 0){
										this.setUserAsProfessional();
									}
									/*this.changeDetectorRef.detectChanges()
			                        this.tiersSearchList.forEach(t =>{
			                            if(t.tiers.ID == el.ID){
			                                this.tiersSelected.push(t.tiers);
			                            }
			                        })
									*/
			                        this._groupSearchList();
									
			                        this.changeDetectorRef.detectChanges()
			                    })
	}
	
	changeLocation(location: any) {
		//console.log('select location', location)
		this._searchTiersProfessional();
    }

    _getConsultationTypeGroupe(visiteId: any){
        let tab = [];
      //  console.log('init this.selectedConsultation:',this.selectedConsultation);
		this.consultationGroup=[];
		
		let _opts:any={
						principal: [0,2]
					};
					
		this.consultationService
        .getConsultationTypeGroupe(visiteId,_opts)
        .subscribe((res: JSONRpcResponse) => {
            tab = res.result;
            this.consultationGroup = tab.filter(group => group.principal === 0 || group.principal === 2)
//            console.log("selectConsultation consultationGroup:",this.consultationGroup,tab);
			this.changeDetectorRef.detectChanges()
        })
    }
	
    changeTypeGroup(type: any) {

       // console.log('select type', type)

        this._getConsultationTypeGroupe(type.ID);

        if (typeof type === 'object') {
            this.getFormulairesList(type);
			this.tiersCtrl.enable({onlySelf:true})
			this.showBtn(type);
            if (type.lieux && this.visiteType=='ponctuel')
                this.loadConsultationLocations(type.lieux)

		this._searchTiersProfessional();
				
        } else if(type ===''){
			this.tiersCtrl.disable({onlySelf:true});
		}
    }
    
    loadConsultationLocations(lieux: any) {
        //console.log('select lieux', lieux)
        if (lieux != undefined && lieux.length > 0) {
			this.consultationLocation=[];
			this.towns=[];
            this.subscriptions.push(
                this.tiersServices
                    .searchByType(lieux)
                    .subscribe((res: JSONRpcResponse) => {
                        let tt:any={
							
						}
						res.result.sort((a,b) => ( a.NOM > b.NOM) ? 1:-1);
                        res.result.forEach((result: any) => {
                            
                            let ll:any={
                                nom: result.NOM ? result.NOM : '',
                                number: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.number) ? result.adresses.PRINCIPALE.number : '',
                                complement: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.complement) ? result.adresses.PRINCIPALE.complement : '',
                                street: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.street) ? result.adresses.PRINCIPALE.street : '',
                                zipCode: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.IDzipcode) ? result.adresses.PRINCIPALE.IDzipcode : '',
                                town: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.town) ? result.adresses.PRINCIPALE.town : '',
                                ID: result.ID ? result.ID : '',
								type:(result.type_libelle != undefined && result.type_libelle) ? result.type_libelle : ''

                            };
                            this.consultationLocation.push(ll)
                            
                            if (tt[ll.town]==undefined) {
							   tt[ll.town]={
								   label:ll.town,
								   consultations:[]
							   };
						    }
                            tt[ll.town].consultations.push(ll);
                            console.log("select lieux one",ll)
                        })
                        
	                    let tws:any[]= Object.keys(tt).sort((a,b) => ( a > b) ? 1:-1);
						   for (let i = 0; i <tws.length; i++) {
								//tt[tws[i]].consultationLocation.sort((a,b) => ( a.nom > b.nom) ? 1:-1);
								this.towns.push(tt[tws[i]]);
						   }
						  this.changeDetectorRef.detectChanges()   
						//   console.log('select lieux after', this.consultationLocation,this.towns)
                    })
            )
            
            
        }
    }
    
    changeDate(event: any) {
		//console.log("changeDate",event,this.valueDebut,this.durationInput)
        if (event.value) {
            //if (moment.isDate(event.value)) {
                this.invalidDate = false
                // this.dateInput = event.value.toDate();
                // console.log("changeDate after",event.value,this.dateInput)
                this.toLoadDate.next(event.value.toDate());
                this.toLoadConsultion.next(true); 
				
				
				
                this.changeDetectorRef.detectChanges();
           /*   
            } else {
                this.invalidDate = true
                
            }*/
        } else {
            this.invalidDate = true
        }
    }
    /**
    CONSULTATION END
     */
     
	getFormulairesList(consultation: any,eventType = null) {
		this.formulairesList = []

        if(!consultation.type){
            this.formulairesList = consultation.actions
        }else{
            this.formulairesList = consultation.type.actions
        }
		// this.selectedFormulaires=this.formulairesList;
		this.selectedFormulaires = this.formulairesList.filter((form) => form.principal)
		
	//	console.log('getFormulairesList',consultation);
     //   console.log("getFormulairesList data:",this.data);
        if(this.data.startTimeInput){
            this.valueDebut = this.data.startTimeInput;
        }else{
			if (consultation.date_debut!=undefined)
            	this.valueDebut = this.valueDates(consultation.date_debut);
        }
		if (consultation.date_fin!=undefined)
        	this.valueFin = this.valueDates(consultation.date_fin);
	    if (consultation.date_debut!=undefined)
        	this.dateInput=new Date(consultation.date_debut);
        
        if (consultation.intervalle!=undefined && consultation.intervalle>0)
               this.durationInput=consultation.intervalle;
        else
             this.durationInput=this.durationDefaultInput;
        this.timeChange(this.valueDebut,'debut',eventType);    
        this.toLoadDate.next(this.dateInput);     
        this.toLoadConsultion.next(true);  
        this.changeDetectorRef.detectChanges()
	}

	prefillVisite(visite: any) {
		//console.log('prefillVisite',visite);
		this.selectedAccompagnants = visite.accompagnants
		this.selectedFormulaires = visite.formulaires
		this.visiteDateDebut = visite.date_debut
		this.visiteDateFin = visite.date_fin
		this.visiteEtat = visite.etat.key
		this.selectedMember = visite.tiers
		this.disabledDateDeFin = false
		if (visite.professionels && Array.isArray(visite.professionels))
			this.visiteProfessionels=this.idFiy(visite.professionels);
		else
			this.visiteProfessionels = visite.professionels && visite.professionels.object!=undefined ? this.idFiy(visite.professionels.object) : []
		//console.log('visiteProfessionels', this.visiteProfessionels)
		//console.log('prefillVisite',this.visiteDateDebut,this.visiteDateFin);
		this.visiteDateDebut=this.valueDates(this.visiteDateDebut);
		this.visiteDateFin=this.valueDates(this.visiteDateFin);
		//console.log('prefillVisite after',this.visiteDateDebut,this.visiteDateFin);
		
		if (visite.consultation!=undefined) {
			this.consultation=visite.consultation;
			this.dateInput=new Date(visite.consultation.date_debut);
			/*if (visite.consultation.domicile!=undefined
				&& visite.consultation.domicile
				) 
		    	this.visiteType='domicile';
		    if (visite.consultation.ponctuel!=undefined
				&& visite.consultation.ponctuel
				) 
		    	this.visiteType='ponctuel';	
		    */
		}
		
		//console.log('prefillVisite visiteType ',this.visiteType);
		this.valueDebut = this.visiteDateDebut;
		this.valueFin = this.visiteDateFin;
		
		if (visite.duration!=undefined)
		    this.durationInput=visite.duration;
		this.toLoadDate.next(this.dateInput);
		this.toLoadConsultion.next(true);
	//	console.log(this.valueDebut, this.valueFin)
		this.updateSliderObjEdit("consultationSelect");
		this.changeDetectorRef.detectChanges()
	}

	valueDates(date: any) {
		let dateObj = new Date(date)
		return `${dateObj.getHours()}:${dateObj.getMinutes()}`
	}

	timeChange(event: any, position: string, eventType = "time") {
//		console.log("timeChange",event,position,eventType)
		
		

		if (position === 'debut') {
			this.visiteDateDebut = event
			
			this.timepickerColor = null;
			this.timeSlots.forEach(slot => {
						let date = new Date(slot.debut);
						let newDate = new Date(date.toISOString().split('T')[0]);
						newDate.setHours(event.split(":")[0], event.split(":")[1]);
						
						if (date.getTime() == newDate.getTime() && !slot.disponible) {
							this.timepickerColor = "red";
						}
			});
			
		} 
		//else {
			let dt:Date=new Date();
			let hours = Number.parseInt(this.visiteDateDebut.split(':')[0], 10)
		    let minutes = Number.parseInt(this.visiteDateDebut.split(':')[1], 10)
			dt.setHours(hours);
			dt.setMinutes(minutes);
			
			//let dt:Date=this.datePlusTime(this.visiteDateDebut);
		//	console.log('fin0',this.visiteDateDebut,dt,this.durationInput);
			dt = this.dateAdd(dt,'minute',this.durationInput);
			this.valueFin=dt.getHours()+":"+dt.getMinutes().toString().padStart(2, '0');
			console.log('fin',this.durationInput,this.visiteDateDebut,this.visiteDateFin);
			
			this.visiteDateFin = this.valueFin
		//}
		this.visiteChangeDebounce.next(eventType);
		this.changeDetectorRef.detectChanges()
	}
	 dateAdd(date:any, interval:string, units:number) {
		  if(!(date instanceof Date))
		    return undefined;
		  let ret:any = new Date(date); //don't change original date
		 
		  switch(String(interval).toLowerCase()) {
		    case 'year'   :  ret.setFullYear(ret.getFullYear() + units);;  break;
		    case 'quarter':  ret.setMonth(ret.getMonth() + 3*units); ;  break;
		    case 'month'  :  ret.setMonth(ret.getMonth() + units); ;  break;
		    case 'week'   :  ret.setDate(ret.getDate() + 7*units);  break;
		    case 'day'    :  ret.setDate(ret.getDate() + units);  break;
		    case 'hour'   :  ret.setTime(ret.getTime() + units*3600000);  break;
		    case 'minute' :  ret.setTime(ret.getTime() + units*60000);  break;
		    case 'second' :  ret.setTime(ret.getTime() + units*1000);  break;
		    default       :  ret = undefined;  break;
		  }
		  return ret;
	}

	generateVisiteEtatList() {
		this.visiteService.getVisiteEtats().subscribe((res: JSONRpcResponse) => {
			this.etatList = res.result
			//if (this.currentAction!='edit')
				for(let i=0;i<this.etatList.length;i++) {
						/*if (this && this.etats[i].key==this.consultation.etat.key) {
							this.statusInput=this.etats[i];
						} else {*/
							if (this.etatList[i].key=="CREE")
								this.visiteEtat=this.etatList[i].key;
						//}      
				}
		     this.changeDetectorRef.detectChanges()   
			
		})
	}

	getActions() {
		let actions = []
		if (this.selectedFormulaires) {
			this.selectedFormulaires.forEach((form: any) => {
				actions.push(
					{
						idForm: form.IdForm,
						action: form.ID,
					}
				)
			})
		}
		return actions
	}
	submitVisiteForm(event: any,isNew:boolean=false) {
		let tiersID=null;

		if (!this.visiteEditable)
			return;

		this.visiteEditable = false;
		if (this.selectedMember) {
			if (this.selectedMember.ID==undefined)
		  		tiersID=this.selectedMember;
		    else
		    	tiersID=this.selectedMember.ID;
	    }
	    else {
            if (this.intervention && this.intervention.tiers.ID)
                tiersID=this.intervention.tiers.ID;
            else {
                if ((this.data && this.data.dossier   && this.data.dossier.tiers && this.data.dossier.tiers.ID))
                         tiersID=this.data.dossier.tiers.ID;
                
            }
            
        }
		
	//	console.log("se beforet visite",this.visiteDateDebut,this.visiteDateFin)
		let opt = {
			datestring:false,
			tiers: this.data.lots?this.setTiersSelected[0].ID:tiersID,
			interval: null
		}
		let _options = this.getInfosCurrentVisite(opt)
		/*let _options = {
			datedebut: this.datePlusTime(this.visiteDateDebut),
			datefin: this.datePlusTime(this.visiteDateFin),
			visiteetat: this.visiteEtat,
			domicile: this.visiteType === 'domicile' ? 1 : 0,
			ponctuel: this.visiteType === 'ponctuel' ? 1 : 0,
			professionels: (this.visiteProfessionels && this.visiteProfessionels.length) > 0 ? this.visiteProfessionels : this.idFiy(this.selectedTiers),
			consultationid: this.selectedConsultation ? this.selectedConsultation.ID : 0,
			id: this.data.visite ? this.data.visite.ID : 0,
			tiers: this.data.lots?this.setTiersSelected[0].ID:tiersID ,
			actions: this.getActions(),
			accompagnants: this.idFiy(this.selectedAccompagnants),
			suivi: this.intervention && this.intervention.ID,
			instruction: this.instruction ,
			titre: this.titre ? this.titre:null,
			commentaire:this.comment ? this.comment:null,
			consultation: {
                type: this.typeInput,
                date: this.dateInput,
                lieu: this.locationInput
            },
            domicileVisite: this.selectedDomicile && this.selectedDomicile.ID? this.selectedDomicile.ID: null,
            groupe: this.typeGroupe != ''? this.typeGroupe: null
		}*/
		//console.log("get tiers",tiersID, this.selectedMember,this.intervention,this.data);
	//	console.log("set visite",_options)
		
		this.errors =[]
        this.errorMessage ="";
        
        if (
            _options.domicile==0 
            && _options.ponctuel==0
            &&_options.consultationid==0)
            this.errors.push("Une séance pour ce choix");
		if (
            _options.domicile!=0 
            || _options.ponctuel!=0)
           {
              if  (_options.consultation.type==undefined || !_options.consultation.type)
    		          this.errors.push("Un type de séance pour ce choix");
    		          
    		  if  (_options.ponctuel!=0 &&( _options.consultation.lieu==undefined || !_options.consultation.lieu))
                      this.errors.push("Un lieu pour la séance");       
    		          
    		  
		 }
		if (
            !(_options.datedebut instanceof Date)
           || !(_options.datefin instanceof Date)
		   || (_options.datedebut instanceof Date && _options.datedebut.toString() == 'Invalid Date')
		   || (_options.datefin instanceof Date && _options.datefin.toString() == 'Invalid Date')
           )
          this.errors.push("Date et heure du rendez-vous");
         if (
            _options.visiteetat==undefined || !_options.visiteetat
           )
          this.errors.push("Etat");  
		  
		  
		  if (
		    _options.professionels==undefined || _options.professionels.length==0
		            )
		  this.errors.push("Professionel(s)");   
         if (
            _options.tiers==undefined || !_options.tiers
           )
          this.errors.push("Tiers");   
	  if (this.errors.length>0) {
            
            this.errorMessage="<ul><li>"+this.errors.join("</li><li>")+"</li></ul>";
			this.visiteEditable = true;
            this.changeDetectorRef.detectChanges();
        }
        else { 
            if(this.setTiersSelected.length>0){
				
				
				
                let _opt:any = {};
                let counter = 0;
                this.setTiersSelected.forEach((res) =>{
					var opt = {
						datestring:false,				
						interval: this.durationInput,
						tiers: res.ID
					}
					//_opt.push(
                    _opt[counter] = this.getInfosCurrentVisite(opt);
					 /*{
    
                        datedebut: this.datePlusTime(this.visiteDateDebut),
                        datefin: this.datePlusTime(this.visiteDateFin),
                        visiteetat: this.visiteEtat,
                        domicile: this.visiteType === 'domicile' ? 1 : 0,
                        ponctuel: this.visiteType === 'ponctuel' ? 1 : 0,
                        professionels: (this.visiteProfessionels && this.visiteProfessionels.length) > 0 ? this.visiteProfessionels : this.idFiy(this.selectedTiers),
                        consultationid: this.selectedConsultation ? this.selectedConsultation.ID : 0,
                        id: this.data.visite ? this.data.visite.ID : 0,
                        tiers: res.ID,
                        actions: this.getActions(),
                        accompagnants: this.idFiy(this.selectedAccompagnants),
                        suivi: this.intervention && this.intervention.ID,
                        instruction: this.instruction,
                        titre: this.titre ? this.titre:null,
                        commentaire:this.comment ? this.comment:null,
                       // listeDeTiers: this.setTiersSelected,
                        interval: this.durationInput,
                        consultation: {
                            type: this.typeInput,
                            date: this.dateInput,
                            lieu: this.locationInput
                        },
                        domicileVisite: this.selectedDomicile && this.selectedDomicile.ID? this.selectedDomicile.ID: null,
                        groupe: this.typeGroupe != ''? this.typeGroupe: null
    
                    }*/
					
                    counter++;
                });
			//	console.log("visit setManyVisite",_opt)
                this.visiteService
                .setManyVisite(_opt)
                .subscribe((res: JSONRpcResponse) => {
					this.visiteEditable = false;
                    console.log(res, 'res')
                    if (res.result){
                        this.dialogRef.close(true);
                        this.stateService.updateVisiteReload(true);
						
						if (isNew && res.result.length>0) {
							
							let vs:any=res.result[0];
							let _optDos:any={
										rdv: false,
										getFormulairesHtml: false
									}
							if (vs.tiers!=undefined) {		
								 this.dossierService.get(vs.tiers.dossierID,_optDos).subscribe((dossier: JSONRpcResponse) =>{
									let dataVs:any= {
									                action: "create",
									                dataType: "rdv",
									                dossier: dossier.result,
													old_visit: vs,		
													title: "Création d'un rendez-vous",
									                create: true,
									            };
									
									if (this.instruction!=undefined)
										dataVs["instruction"]=this.instruction;
												
							        this.dialogService.open(VisiteActionsDialog, {
							            data: dataVs,
							            height: "95vh",
							            width: "80vw",
							            draggable: true,
							            resizable: true,
							            minimizable: true,
							            maximizable: true,
							        }, (res: any) => {
							                   console.log(res)
							                    
								                    let _refresh={
														type: "visite",
														data:res
													};
								    //                console.log("subheader VisiteActionsDialog",res)
								                    this.stateService.updateRefresh(_refresh)
								                   /* if (res.consultation!=undefined)
							                    		this.stateService.updateConsultation(res.consultation);
										                    */
										 });
									
							});
							}
	                    }
					} else
						this.visiteEditable = true;
                })
              }/*
			  else{
                this.visiteService
                .set(_options.id, _options.consultationid, _options)
                .subscribe((res: JSONRpcResponse) => {
                    if (res.result) {
                        console.log(res.result, 'res.result')
                        this.dialogRef.close(true);
                        this.stateService.updateVisiteReload(true);
                    }
                })
              }*/
		}	

	}

	getInfosCurrentVisite(options = {datestring:false,tiers: null, interval: null}){
		//console.log("this.visiteDateDebut",this.visiteDateDebut,this.visiteDateFin,this.selectedConsultation)
		let _vst:any = {
			datedebut: this.datePlusTime(this.visiteDateDebut,options.datestring),
			datefin: this.datePlusTime(this.visiteDateFin,options.datestring),
			visiteetat: this.visiteEtat,
			domicile: this.visiteType === 'domicile' ? 1 : 0,
			ponctuel: this.visiteType === 'ponctuel' ? 1 : 0,
			professionels: (this.visiteProfessionels && this.visiteProfessionels.length) > 0 ? this.visiteProfessionels : this.idFiy(this.selectedTiers),
			consultationid: this.selectedConsultation ? this.selectedConsultation.ID : 0,
			lieuid: this.selectedConsultation && this.selectedConsultation.lieu? this.selectedConsultation.lieu.ID: 0,
			id: this.data.visite ? this.data.visite.ID : 0,
			tiers: options.tiers != undefined? options.tiers: null ,
			actions: this.getActions(),
			accompagnants: this.idFiy(this.selectedAccompagnants),
			suivi: this.intervention && this.intervention.ID,
			instruction: this.instruction ,
			titre: this.titre ? this.titre:null,
			commentaire:this.comment ? this.comment:null,
			interval : options.interval != undefined? options.interval: null ,
			consultation: {
                type: this.typeInput,
                date: this.dateInput,
                lieu: this.locationInput
            },
            domicileVisite: this.selectedDomicile && this.selectedDomicile.ID? this.selectedDomicile.ID: null,
            groupe: this.typeGroupe != ''? this.typeGroupe: null
		}
		let _vst2:any =Object.assign({},_vst)
		//console.log("this.visiteDateDebut after",_vst2)
		
		if (_vst2.datedebut!=undefined 
			&& Array.isArray(this.timeSlots)) {
			//console.log("this.visiteDateDebut datedebut",_vst2.datedebut,this.timeSlots);
			this.timepickerColor = null;
			this.timeSlots.forEach(slot => {
						let date = new Date(slot.debut);
						let zhi=moment(date).format("HHmm");
						let newDate = moment.parseZone (_vst2.datedebut);
						let hi=newDate.format("HHmm");
						
						//newDate.setHours(_vst2.datedebut.split(":")[0], _vst2.datedebut.split(":")[1]);
//						console.log("this.visiteDateDebut slot",slot,date,newDate,zhi,hi);
						if (zhi == hi && !slot.disponible) {
							this.timepickerColor = "red";
						//	console.log("this.visiteDateDebut slot red",slot,date,newDate);
						}
			});
		}
		return _vst2;
	}

	datePlusTime(time: string,datestring:boolean=false) {
		//const consultation = this.consultation ? this.consultation : this.selectedConsultation
		//const  consultation=
		//console.log("datePlusTime ",time,this.selectedConsultation.date_debut,this.dateInput)
		if (this.selectedConsultation==undefined 
		      && this.dateInput==undefined)
		    return null;
			
		let date = this.selectedConsultation ? new Date(this.selectedConsultation.date_debut) : new Date(this.dateInput)
		let hours = Number.parseInt(time.split(':')[0], 10)
		let minutes = Number.parseInt(time.split(':')[1], 10)
		date.setHours(hours)
		date.setMinutes(minutes)
//		console.log("datePlusTime",this.selectedConsultation,this.dateInput,  date,time.split(':'),time,hours,minutes)
		
		if (!datestring)
			return date;
		
		let  dts:string=date.getFullYear()+"-";
		let month:number=date.getMonth()+1;
		if (month<10) 
			dts+="0";
		dts+=month+"-";
		
		let day:number=date.getDate();
		if (day<10) 
			dts+="0";
		dts+=day+"T";
		let hour:number=date.getHours();
		if (hour<10) 
			dts+="0";
		dts+=hour+":";
		let min:number=date.getMinutes();
		if (min<10) 
			dts+="0";
		dts+=min+":00Z";
		//var dts:string=date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+"T"+date.get()+":"+date.getMinutes()+":00Z";
		//var dts:string=date.toISOString();
		return dts
	}

	trueFalseify(value: boolean) {
		return value ? 1 : 0
	}
	initProfessionelsSearch() {
		this.proCtrl.valueChanges.pipe(
			debounceTime(400),
			distinctUntilChanged()
		).subscribe(term => {
			
			if (this.typeInput
			 && term.length>0 ) {
				let _opts={
					
					consultation_type : this.typeInput
				}
				
				this.tiersServices.searchTiersForSuivi(term,_opts)
					.subscribe((res: JSONRpcResponse) => {
					this.tiersSearchList = res.result
					this.changeDetectorRef.detectChanges()
				})
				
				let _optS:any={
									/*	tiersId: this.tiersId,*/
										term: term,
										location: this.locationInput
				                    };
				if (this.getTiersSelected!=undefined 
					&& this.getTiersSelected.length>0 
					&& this.getTiersSelected[0]!=undefined 
					&& this.getTiersSelected[0].ID!=undefined 
					)
					_optS["tiersId"]=this.getTiersSelected[0].ID;
                this.tiersServices
                    .getTiersByConsultationType(this.typeInput.ID,_optS )
                    .subscribe((res: JSONRpcResponse) => {
                        this.tiersSearchList = res.result
						/*this.changeDetectorRef.detectChanges()
                        this.tiersSearchList.forEach(t =>{
                            if(t.tiers.ID == el.ID){
                                this.tiersSelected.push(t.tiers);
                            }
                        })
						*/
                        this._groupSearchList();
						
                        this.changeDetectorRef.detectChanges()
                    })
				
			}
		})
	}

	initTiersSearch(){
		this.tiersCtrl.valueChanges.pipe(
			debounceTime(400),
			distinctUntilChanged()
		).subscribe(term => {
		//	console.log('tiersList serach ', term);
			//console.log(this.typeInput, this.selectedConsultation)
			let _opts={
				tierstype:this.listTiersType
			}
			
			if (term!=undefined && (this.typeInput || this.selectedConsultation))
				this.tiersServices.searchTiersForVisite(term,_opts).subscribe((res: JSONRpcResponse) => {
					this.tiersList = res.result
			//		console.log(this.tiersList, 'tiersList')
				})
		})
	}

	initAccompagnantsSearch() {
		this.accompagnantCtrl.valueChanges.pipe(
			debounceTime(400),
			distinctUntilChanged()
		).subscribe(term => {
			
			if (this.typeInput || this.selectedConsultation) {
				let _opts={
						consultation: this.selectedConsultation,
						consultation_type : this.typeInput
					}
				
				this.visiteService.searchAccompagnants(term,_opts).subscribe((res: JSONRpcResponse) => {
					this.accompagnantsList = res.result
					this.changeDetectorRef.detectChanges()
				})
			}
		})
	}

	selectTiers(tiers: any) {
		if (this.selectedTiers.indexOf(tiers) === -1) {
			this.selectedTiers.push(tiers)
		}
		this.searchTerm = ''
		this.tiersSearchList = []
		this.changeDetectorRef.detectChanges()
	}
	supprimer(tiers: any) {
		const index = this.selectedTiers.indexOf(tiers)
		if (index >= 0) {
			this.selectedTiers.splice(index, 1)
		}
		this.changeDetectorRef.detectChanges()
	}
	supprimerAccompagnants(accompagnant: any) {
		const index = this.selectedAccompagnants.indexOf(accompagnant)
		if (index >= 0) {
			this.selectedAccompagnants.splice(index, 1)
		}
		this.changeDetectorRef.detectChanges()
	}
	selected(event: any) {
		this.selectedTiers.push(event.option.value)
		this.tiersInput.nativeElement.value = ''
		this.proCtrl.setValue(null)
		
		this.toLoaProfesionnel.next(this.idFiy(this.selectedTiers))
		this.toLoadConsultion.next(true);  
	}
	accompagnantsSelected(event: any) {
		this.selectedAccompagnants.push(event.option.value)
		this.accompagnantInput.nativeElement.value = ''
		this.accompagnantCtrl.setValue(null)
	}

    ajouterDuree(heureMinute, duree) {

        const [heureStr, minuteStr] = heureMinute.split(':');

        const heure = parseInt(heureStr, 10);
        const minute = parseInt(minuteStr, 10);

        const dureeHeures = Math.floor(duree / 60);
        const dureeMinutes = duree % 60;

        let nouvelleHeure = heure + dureeHeures;
        let nouvelleMinute = minute + dureeMinutes;

        if (nouvelleMinute >= 60) {
            nouvelleHeure += Math.floor(nouvelleMinute / 60);
            nouvelleMinute %= 60;
        }

        const heureFormattee = String(nouvelleHeure).padStart(2, '0');
        const minuteFormattee = String(nouvelleMinute).padStart(2, '0');

        return `${heureFormattee}:${minuteFormattee}`;
    }

    afficherPage(numeroPage, liste){
        const debut = numeroPage * this.PaginationInstruction;
        const fin = debut + this.PaginationInstruction;
         var elementsPage;;
		 if(liste){
             elementsPage = liste.slice(debut,fin);
        }
        return elementsPage;
    }

    relationsTiers(tiers: any,tiersAdded: boolean = true){
		let _optDos:any={
			rdv: false,
			getFormulairesHtml: false
		}
        this.dossierService.get(tiers.dossierID,_optDos).subscribe((dossier: JSONRpcResponse) =>{
            if(dossier){
				
			//	this._addDossierTiersSelection(tiers);
				
                dossier.result.tiers.typeRelation = "";
				dossier.result.tiers.typeConsultation = "";
			//	console.log("relationsTiers",dossier);			
				const currentTiersIdx = this.getTiersWithRelations.findIndex(t=>t.dossierID == tiers.dossierID);
				if(currentTiersIdx != -1 && dossier.result.formulaires != undefined && dossier.result.formulaires && dossier.result.formulaires.formulaires != undefined){
					this.getTiersWithRelations[currentTiersIdx].formulaires = dossier.result.formulaires.formulaires;
				}
                var groupeRelation = [dossier.result.tiers];
              //  console.log('relationsTiers dossier.result:',dossier.result);
                dossier.result.foyers.forEach(foyer => {
                    foyer.foyer.typeRelation = "Foyer";
                    groupeRelation.push(foyer.foyer);
                });
				
				
				let aDossier:any[] =[];
				let tos:any ={};
				let ii:number=0;
                if(dossier.result && dossier.result.relations.to.length>0){
                   
					 dossier.result.relations.to.forEach(tier => {
                        if((!this.getTiersWithRelations.includes(tier.tiers))){
                            tier.tiers.id = tier.tiers.ID;
                            tier.tiers.born =tier.tiers.DATENAISSANCE ?  this.formaterDate(tier.tiers.DATENAISSANCE): '<div class="d-none">/div>';
                            if(tier.tiers.adresses.PRINCIPALE){
                                tier.tiers.commune = tier.tiers.adresses.PRINCIPALE.town;
                            }else{
                                tier.tiers.commune = "";
                            }
                            tier.tiers.typeConsultation = tier.tiers.type;
                            tier.tiers.typeRelation = tier.relation.libelle;
							tier.tiers.lastRdv=this._getLastRdv(tier.tiers);
							tier.tiers.formulaires = tier.formulaires != undefined && tier.formulaires.formulaires != undefined
							? tier.formulaires.formulaires
							: "";
//							console.log("_addDossierTiersSelection to",tier);
							this._addDossierTiersSelection(tier.tiers);
                           // this.getTiersWithRelations.push(tier.tiers);
							
                            if(tier.tiers.physique)
                                groupeRelation.push(tier.tiers);
                            this.lengthInstruCount++;
							if (tier.tiers.dossierID!=undefined) {
								aDossier.push( tier.tiers.dossierID);
								tos[tier.tiers.dossierID+""]={index: ii, destination:"to"};
								
						  		}
						  ii++;
                        }
                       // this.changeDetectorRef.detectChanges();
                    });
                }

                if(dossier.result && dossier.result.relations.from.length>0){
                   ii=0;
					 dossier.result.relations.from.forEach(tier => {
                        if((!this.getTiersWithRelations.includes(tier.tiers))){
                            tier.tiers.id = tier.tiers.ID;
                            tier.tiers.born =tier.tiers.DATENAISSANCE ? this.formaterDate(tier.tiers.DATENAISSANCE): '<div class="d-none">/div>';
							tier.tiers.formulaires = tier.formulaires != undefined && tier.formulaires.formulaires != undefined
							? tier.formulaires.formulaires
							: "";
                            if(tier.tiers.adresses.PRINCIPALE){
                                tier.tiers.commune = tier.tiers.adresses.PRINCIPALE.town;
                            }else{
                                tier.tiers.commune = "";
                            }
							tier.tiers.typeConsultation=tier.tiers.type;
                            tier.tiers.typeRelation = tier.relation.libelle + " de";
							tier.tiers.lastRdv=this._getLastRdv(tier.tiers);
							//console.log("_addDossierTiersSelection from",tier);
							this._addDossierTiersSelection(tier.tiers);
							// this.getTiersWithRelations.push(tier.tiers);
                            if(tier.tiers.physique)
                                groupeRelation.push(tier.tiers);

							if (tier.tiers.dossierID!=undefined) {
								aDossier.push( tier.tiers.dossierID);
								tos[tier.tiers.dossierID+""]={index: ii, destination:"from"};
								
							}
							ii++;
                            this.lengthInstruCount++;
                        }
						//this.changeDetectorRef.detectChanges();
                    })
                }
			//	console.log("VisiteActionsDialog event",aDossier,tos);
				if (aDossier.length>0) {
					
					let _optDoss={};
					this.dossierService.getVisiteList(aDossier,_optDoss).subscribe((res: JSONRpcResponse) =>{
					//	console.log("VisiteActionsDialog rdvs",res);
												
						if (res.result &&res.result.length>0) {
						//	console.log("VisiteActionsDialog rdvs",res.result,this._getTiersWithRelationsDossierIDIndex);
							res.result.forEach((rdvs: any) => {
								//console.log("DossierFoyerComponent stats before",stats);
								if (this._getTiersWithRelationsDossierIDIndex[rdvs.TiersID]!=undefined) {
									//console.log("DossierFoyerComponent stats tos",tos[stats.ID]);
									
									if (this.getTiersWithRelations[this._getTiersWithRelationsDossierIDIndex[rdvs.TiersID]]!=undefined) {
										let rel:any=this.getTiersWithRelations[this._getTiersWithRelationsDossierIDIndex[rdvs.TiersID]];
										rel.lastRdv=this._getLastRdv(rdvs);
										
										this.getTiersWithRelations[this._getTiersWithRelationsDossierIDIndex[rdvs.TiersID]]=rel;
											
									}
									
								}
							});	
							this.changeDetectorRef.detectChanges();
						}	
					});	
					
					this.dossierService.getFormulaireHTMLList(aDossier,_optDoss).subscribe((res: JSONRpcResponse) =>{
						//console.log("VisiteActionsDialog htmls",res);
						
						if (res.result &&res.result.length>0) {
//							console.log("VisiteActionsDialog htmls",res.result,this._getTiersWithRelationsDossierIDIndex);
							res.result.forEach((htmls: any) => {
								//console.log("DossierFoyerComponent stats before",stats);
								if (this._getTiersWithRelationsDossierIDIndex[htmls.TiersID]!=undefined) {
									//console.log("DossierFoyerComponent stats tos",tos[stats.ID]);
									
									if (this.getTiersWithRelations[this._getTiersWithRelationsDossierIDIndex[htmls.TiersID]]!=undefined) {
										let rel:any=this.getTiersWithRelations[this._getTiersWithRelationsDossierIDIndex[htmls.TiersID]];
										rel.formulaires=htmls.html.formulaires;
										this.getTiersWithRelations[this._getTiersWithRelationsDossierIDIndex[htmls.TiersID]]=rel;
										
									}
									
								}
							});	
							this.changeDetectorRef.detectChanges();
						}	
					});	
				}
				
                if(tiersAdded)
                    this.listDomiciles.push(groupeRelation);
                if(!this.selectedDomicile){
                    if(this.modeEdit){
                        this.listDomiciles.forEach((groupeRelation,index) => {
                            const indexCurrentTiers = groupeRelation.findIndex(tiers=>tiers.ID == this.data.visite.consultation.lieu.ID);
                            if(indexCurrentTiers != -1)
                                this.selectedDomicile = this.listDomiciles[index][indexCurrentTiers]
                        }); 
                    }
                    else{
                        this.selectedDomicile = this.listDomiciles[0][0];
                    }
                }
               // this.changeDetectorRef.detectChanges();
            }
            this.changeDetectorRef.detectChanges();
        });
    }

    SuppRelationsTiers(tiers: any){
		let _optDos:any={
					rdv: false
				}
        this.dossierService.get(tiers.dossierID,_optDos).subscribe((dossier: JSONRpcResponse) =>{
            if(dossier){
                //console.log("selectedListTiers dossier:",dossier.result.relations);
                if(dossier.result.relations.to != undefined && dossier.result.relations.to.length>0){
                    dossier.result.relations.to.forEach(tier => {
                        if(tier){
                            const getIndexRelationTo = this.getTiersWithRelations.findIndex((set) => set.id === tier.tiers.ID);
                            if(getIndexRelationTo>=0){
                                //console.log("getTiersWithRelations to:",this.getTiersWithRelations[getIndexRelationTo]);
                                this.getTiersWithRelations.splice(getIndexRelationTo,1);
                            }
                        }
                    })
                }

                if(dossier.result.relations.from != undefined && dossier.result.relations.from.length>0){
                    dossier.result.relations.from.forEach(tier => {
                        if(tier){
                            const getIndexRelationFrom = this.getTiersWithRelations.findIndex((set) => set.id === tier.tiers.ID);
                            if(getIndexRelationFrom>=0){
                                //console.log("getTiersWithRelations from:",this.getTiersWithRelations[getIndexRelationFrom]);
                                this.getTiersWithRelations.splice(getIndexRelationFrom,1);
                            }
                        }
                    })
                }
            }
            this.lengthInstruCount = this.getTiersWithRelations.length;
            this.changeDetectorRef.detectChanges();
        });   

    }

    selectedListTiers(event: any){

        const index = this.getTiersWithRelations.findIndex((set) => set.ID === event.option.value.ID);
        if(index == -1 ){
            event.option.value.checked = true;
            this.getTiersSelected.push(event.option.value);
			this._addDossierTiersSelection(event.option.value);
           // this.getTiersWithRelations.push(event.option.value);
            this.setTiersSelected.push(event.option.value);
        }

        if(this.getTiersSelected.length > 0){
            this.setTiersSelected.forEach((res,index) => {
                if(res){
                    res.id = res.ID;
                    res.born =res.DATENAISSANCE ? this.formaterDate(res.DATENAISSANCE): '<div class="d-none">/div>';
                  
                    if(res.adresses.PRINCIPALE){
                        res.commune = res.adresses.PRINCIPALE.town;
                    }else{
                        res.commune = "";
                    }
                    res.typeConsultation = res.type;
                    this.inited.emit(res);
                }

            });
            this.relationsTiers(event.option.value,index==-1);
        }

        this.lengthInstruCount = this.getTiersWithRelations.length;

        this.tiersListInput.nativeElement.value = '';
        //this.tiersCtrl.setValue(null);
        //console.log("selectChanged getTiersSelected:",this.getTiersSelected,"\ngetTiersWithRelations",this.getTiersWithRelations);
		this.updateSliderObjEdit("addTiers");
        this.changeDetectorRef.detectChanges();
    }

    putInSetTierselected(event: any){
        const index = this.verifChecked.findIndex((item) => item.id === event.id);

        if (index === -1) {
          this.verifChecked.push(event);
        } else {
          this.verifChecked[index].value = event.value;
        }
        this.getTiersWithRelations.forEach(res =>{
            this.inited.emit(res);
        })

    }

    putInSetAllTierselected(event: any){
        this.verifChecked = event;
        this.verifChecked.forEach(res =>{
            const setIndex = this.setTiersSelected.findIndex((set) => set.id === res.id);

            this.getTiersWithRelations.forEach(get =>{
                if((get.id === res.id) && res.value && !this.setTiersSelected.includes(get)){
                    this.selectedConsultation.type.tiers.forEach(type => {
                        if((type.code == get.type)){
                            this.getTiersSelected.push(get);
                            this.setTiersSelected.push(get);
                        }else{
                            this.selectedAccompagnants.push(get)
                        }
                    })
                    
                }else if((get.id === res.id) && !res.value){
                    this.setTiersSelected.splice(setIndex,1);
                    this.getTiersSelected.splice(setIndex,1);
                    this.selectedAccompagnants.splice(setIndex,1);
                }
            })
        });

        if(this.getTiersSelected.length == 0){
            this.drawerLeftIsOpen = false;
        }
        //console.log("selectChanged getTiersSelected:",this.getTiersSelected,"\ngetTiersWithRelations",this.getTiersWithRelations,"\nselectedAccompagnants",this.selectedAccompagnants);
    }

    selectChanged(event: any){
        this.theSelected = event;
        this.verifChecked.forEach(t =>{
            if(this.setTiersSelected.length < 1){
                this.getTiersSelected.push(event);
                this.setTiersSelected.push(event);
            }
            const setIndex = this.setTiersSelected.findIndex((set) => set.id === t.id);
            const test = this.selectedAccompagnants.findIndex((set) => set.id === t.id);
            //console.log("selectChanged setTiersSelected:",this.setTiersSelected);
            event.checked = t.value;
            if(t.value && setIndex == -1){
                console.log("selectChanged event:",event);
            
                this.selectedConsultation.type.tiers.forEach(type => {
                    if((type.code == event.type) && !this.getTiersSelected.includes(event)){
                        this.getTiersSelected.push(event);
                        this.setTiersSelected.push(event);
                    }else if((type.code != event.type) && !this.selectedAccompagnants.includes(event)){
                        this.selectedAccompagnants.push(event);
                    }
                });
            }else if(!t.value && setIndex != -1){
                this.setTiersSelected.splice(setIndex,1);
                this.getTiersSelected.splice(setIndex,1);
                
            }else if(!t.value && test != -1){
                this.selectedAccompagnants.splice(test,1);
            }
        })
		this.visiteChangeDebounce.next("multiTiers");
        console.log("selectChanged getTiersSelected:",this.getTiersSelected,"\nsetTiersSelected:",
				this.setTiersSelected,"\ngetTiersWithRelations",
				this.getTiersWithRelations,'\nselectedAccompagnants',this.selectedAccompagnants);
    }

    supprimerSelectedListTiers(tiers: any){
        const indexGroupeRelation = this.listDomiciles.findIndex(groupRelation=>groupRelation[0].ID == tiers.ID);
        if(indexGroupeRelation != -1){
            this.listDomiciles.splice(indexGroupeRelation, 1);
            var tiersFound: boolean = false;
            this.listDomiciles.forEach(groupeRelation => {
                const indexCurrentTiers = groupeRelation.findIndex(tiers=>tiers.ID == this.selectedDomicile.ID);
                if(indexCurrentTiers != -1)
                    tiersFound = true;
            });
            if(!tiersFound)
                this.selectedDomicile = this.listDomiciles.length>0? this.listDomiciles[0][0]: null;
        }
        
        const index = this.getTiersWithRelations.findIndex((getW) => getW.id === tiers.id);
        const getIndex = this.getTiersSelected.findIndex((getT) => getT.id === tiers.id);
        const setIndex = this.setTiersSelected.findIndex((set) => set.id === tiers.id);

		if (index >= 0){
			this.getTiersWithRelations.splice(index, 1);
            this.SuppRelationsTiers(tiers);
		}
        if(getIndex >= 0){
            this.getTiersSelected.splice(getIndex, 1);
        }
        if(setIndex >= 0){
            this.setTiersSelected.splice(setIndex, 1);
        }

        if(this.getTiersSelected.length == 0){
            this.getTiersWithRelations = [];
            this.selectedAccompagnants = [];
        }
            
      
		this.updateSliderObjEdit("removeTiers");
        this.lengthInstruCount = this.getTiersWithRelations.length;
		this.changeDetectorRef.detectChanges()
    }

    onPagedInstruction(table: any) {
        this.currentPageInstruction = table.currentPage;
    }

    onHeaderClickedInstruction(sort: any) {
        this.sortInstruction = {
            id: sort.active,
            direction: sort.direction.toUpperCase()
        }
		let tbl:any[]=JSON.parse(JSON.stringify( this.getTiersWithRelations));
	//	console.log("onHeaderClickedInstruction",tbl,this.sortInstruction)
		
		
		this.getTiersWithRelations=this.trierTableau(tbl);
		this.loadingTiersRelation=false;
		this.changeDetectorRef.detectChanges();
		//console.log("onHeaderClickedInstruction Trier",this.getTiersWithRelations,this.sortInstruction)
		
    }

    trierTableau(tableau) {
		
		
		
		if (this.sortInstruction["direction"] === "ASC") 
			  return tableau.sort(this._alphabetically(true,this.sortInstruction["id"]));
		else if (this.sortInstruction["direction"] === "DESC")
		    return tableau.sort(this._alphabetically(false,this.sortInstruction["id"]));
		else 
			 return tableau;
		 /*if (ordre === "ASC") {
            return tableau.sort((a, b) => (a[cle] > b[cle]) ? 1 : -1);
          } else if (ordre === "DESC") {
            return tableau.sort((a, b) => (a[cle] < b[cle]) ? 1 : -1);
          } else {
            return tableau;
          }*/
    }

	 _alphabetically(ascending,cle) {
	  return function (a, b) {
	    // equal items sort equally
	    if (a[cle] === b[cle]) {
	        return 0;
	    }

	    // nulls sort after anything else
	    if (a[cle] == undefined ||  a[cle] === null) {
	        return 1;
	    }
	    if (b[cle] == undefined ||  b[cle] === null) {
	        return -1;
	    }

	    // otherwise, if we're ascending, lowest sorts first
	    if (ascending) {
	        return a[cle] < b[cle] ? -1 : 1;
	    }

	    // if descending, highest sorts first
	    return a[cle] < b[cle] ? 1 : -1;
	  };
	}
	
	idFiy(array: any[]) {
		return array.map(item => {
			if (item.ID != undefined) {
				return item.ID
			} else if (item.id != undefined) {
				return item.id
			} else {
				return item
			}
		})
	}

	initConsultationsList() {
		let _opts={ order: this.orderContultation,
		  domicile: 0,
		  ponctuel: 0,
		  visite: true
		 }
		 
		 /*if (this.old_visit!=undefined) {
			
			
			if (this.old_visit.consultation!=undefined
				&&this.old_visit.consultation.type!=undefined
				&&this.old_visit.consultation.type.ID!=undefined
			)
				_opts["type"]=this.old_visit.consultation.type.ID;
			
		 }*/
		 if (this.restriction_type.length>0)
			_opts["restriction"]=this.restriction_type;
		 else {
		 				
 				if(this.data.dossier!= undefined){
 				    if(this.data.dossier.tiers != undefined && this.data.dossier.tiers.type != undefined){
 						_opts["tiersType"]=this.data.dossier.tiers.type;
 					}
 				}
		 }
		 if (this.typeFilterInput!=undefined && this.typeFilterInput!="") {
			_opts["type"]=this.typeFilterInput.ID;
		 }
		 
		 this.loadingConsult=true;
		//let now:any=new Date();
		if (this.dateBeginInput!=undefined) {
//			console.log("dateBeginInput",this.dateBeginInput,this.dateBeginInput instanceof moment)
			if (this.dateBeginInput instanceof Date)
				_opts["datedebut"]=this.dateBeginInput.toLocaleDateString("fr-FR");
			if (this.dateBeginInput instanceof moment)
				_opts["datedebut"]=this.dateBeginInput.format("DD/MM/YYYY");
		}
		if (this.dateEndInput!=undefined) {
			//console.log("dateEndInput",this.dateEndInput,this.dateEndInput instanceof moment)
			if (this.dateEndInput instanceof Date)
				_opts["datefin"]=this.dateEndInput.toLocaleDateString("fr-FR");
			if (this.dateEndInput instanceof moment)
				_opts["datefin"]=this.dateEndInput.format("DD/MM/YYYY");
			
		}
        this.consultationsList=[];
		this.consultationService.consultationListe(_opts).subscribe((res: JSONRpcResponse) => {
			 this.loadingConsult=false;
			
            if( this.data.dateF!=undefined && this.data.dateF && this.data.startTimeInput){
                res.result.forEach(cons =>{
                    if(cons.date_debut.substr(0,10) == this.donnee){
                        this.consultationsList.push(cons);
                    }
                })  
            }else{
                this.consultationsList = res.result;
            }
            
	        this.consultOptions=this.consultFormControl.valueChanges.pipe(
			      startWith(''),
			      map(value => this._filterConsultations(value))
			);
			if (this._defaultConsultValue!=undefined 
			&& this._defaultConsultValue ) {
				this.consultFormControl.setValue(this._defaultConsultValue);
				let event:any={
					 option: {
						value:this._defaultConsultValue
					}
					};
				this.selectConsultation(event);	
				
		    }
			this.changeDetectorRef.detectChanges();
            
		})
	}
	selectMember(event: any) { 
//		console.log('selectMember event:',event)
		this.selectedMember = event.ID ? event.ID : ''
	}
	displayTiers(value: any) {
		console.log(value)
		return value && value.NOM ? value.NOM + ' ' + value.PRENOM + ' - ' + formatDate(value.DATENAISSANCE, 'dd/MM/yyyy', 'fr'):value
	}

	selectConsultation(event: any) {
		//console.log('selectConsultation', event)
		if(event.option.value != ""){
			if(this.tiersCtrl.status == 'DISABLED' ){
				this.tiersCtrl.enable({onlySelf:true});
			}
			if (event.option.value.type!=undefined && event.option.value.type.tiers!=undefined)
				this.listTiersType=event.option.value.type.tiers;
			this.showBtn(event.option.value.type);
            this._getConsultationTypeGroupe(event.option.value.type.ID);
            
			this.getFormulairesList(event.option.value,"consultationSelect");
			
			this.visiteProfessionels=[];
			if (this.selectedConsultation && this.selectedConsultation.professionels!=undefined)
				for(let i=0; i< this.selectedConsultation.professionels.length;i++) {
					this.visiteProfessionels.push(this.selectedConsultation.professionels[i].ID);
				}
			this.toLoaProfesionnel.next(this.visiteProfessionels);
			//this.toLoadConsultion.next(true);  *
			this.timeSlots = event.option.value.visites_plage.plages;
			
			this.isModifyButton=true;
			if (event.option.value.etat!=undefined 
				&& event.option.value.etat.etat!=undefined
				&& ! event.option.value.etat.etat				
								&& !this.isModify
							 )
								this.isModifyButton=false;
				
			
			
			
		} else if(event.option.value == ""){
			this.tiersCtrl.disable({onlySelf:true});
			if(this.tiersEnfant != undefined || this.tiersEnfant != null){
				this.tiersEnfant = null;
			}
			if(this.tiersUsager != undefined || this.tiersUsager != null){
				this.tiersUsager = null;
			}
		}

        if(this.data.lots != undefined && this.selectedConsultation != null){
            this.selectedConsultation.type.tiers.forEach(type => {
                this.getTiersSelected.forEach(typeGet =>{
                    const getIndex = this.getTiersSelected.findIndex((getT) => getT.id === typeGet.id);
                    if(type.code != typeGet.type){
                        typeGet.checked = false;
                        this.getTiersSelected.splice(getIndex,1);
                        this.setTiersSelected.splice(getIndex,1);
                    }
                })
            });
        }
	}

	dateYear(date: string) {
		return new Date(date).getFullYear()

	}

    getInitedEmitter() {
        return this.inited;
    }
	
	toggle(pos: string) {
		
		if (pos == 'right') {
			this.drawerRightIsOpen = !this.drawerRightIsOpen
			
			if (this.drawerRightIsOpen) {
			 
		//	  console.log("toggle slider");
			  // this.toLoadConsultion=true;
			 // this.toLoadConsultion.next(true);
			 this.toLoadConsultionSlider.next(true);
			}
		}

        if(pos == 'left'){
            
            this.drawerLeftIsOpen = !this.drawerLeftIsOpen;
            if (this.drawerLeftIsOpen) {
                //console.log("toggle slider");
                this.toLoadManyVisitor.next(true);
            }
            
        }
		this.changeDetectorRef.detectChanges();
	}

	add(event:any){
		let num = 0;
		
		this.formulaireService.listByCode([ "ENFANT", "MEMBRE", "FOYER" ], []).subscribe((res:any)=> {
			if(event == 'enfant'){
				num=res.result.ENFANT.ID;
			} else if (event == 'usager'){
				num = res.result.MEMBRE.ID;
			}
			
			let data = {
				idAForm: num,
				create: true,
				closeWhenValidate: true,
				v3: true,
			}
			this.dialogService.open(FormDialogFormulaireWithSFComponent, {
				data: data,
				height: "90vh",
				width: "90vw",
				draggable: true,
				resizable: true,
				minimizable: true,
				maximizable: true,
			}, (res:any) => {
				console.log(res)
			})
		})

		
	}

	showBtn(type:any){
		console.log(type)
		this.tiersEnfant = false;
		this.tiersUsager = false;
		this.tiersLabelEnfant="";
		this.tiersLabelUsager="";
		
		if(type && type.tiers && type.tiers.length > 0) {
			this.nbTiers = 0;
			type.tiers.forEach(tier => {
			//	console.log("VisiteActionsDialog showBtn label",tier)
				if(tier.code == 'ENFANT'){
					this.tiersEnfant = true;
					this.nbTiers = this.nbTiers + 1
					this.tiersLabelEnfant=tier.libelle;
				} else if(tier.code == 'USAGER'){
					this.tiersUsager = true;
					this.nbTiers = this.nbTiers + 1
					this.tiersLabelUsager=tier.libelle;
				}
			});
		}
		this.changeDetectorRef.detectChanges();
	}
	
	selectLocation(event: any) { 
		// console.log(event)
	//	this.selectedMember = event.ID ? event.ID : ''
	    
	}
	
	displayAutoLocationList(value: any) {
		//console.log("displayAutoLocationList",value)
		let label:any="";
		this.towns.forEach((r: any) => {
			let cs:any[]=r.consultations;
			let stop:boolean=false;
			cs.forEach((c: any) => {
				if (!stop 
					&& c.ID==value ){
					stop=true;
					label=c.nom;
				}
			});
		})
		return label;
	}
	
	_filterConsultations(value: any): any[] {
		if (value!=undefined && value && typeof value=="string") {
			console.log("_filterConsultations",value,this.consultationsList);
	       let filterValue:any[] = value.toLowerCase().split(" ");
	       
	      return  this.consultationsList.filter(consultation => {
			  let r:boolean=false;
			  let rb:boolean[]=[];
			  for(let i:number=0;i<filterValue.length;i++) {
				  rb[i]=(filterValue[i].length==0);
			  }
			  let label:string=this._getConsultationLabel(consultation);
			  for(let i:number=0;i<filterValue.length;i++) {
				  if (label.toLowerCase().includes(filterValue[i]))
				  		rb[i]=true;
				  	
			  }
			  let nbt:number=0;
			  for(let i:number=0;i<filterValue.length;i++) {
				 if (rb[i])
				   nbt++;
			  } 
			  r=(filterValue.length==nbt);
			  
			//   console.log("_filterConsultations",filterValue,r,label,rb)
			   return r;      
		  } )
	        
	    }
	
	    return this.consultationsList;
	}
  	
  	displayAutoConsultList(value: any) {
		//console.log("displayAutoConsultList",value)
		let label:any="";
		let stop:boolean=false;
		this.consultationsList.forEach((c: any) => {
				if (!stop && c.ID==value.ID ){
					stop=true;
					
				    label= this._getConsultationLabel(c);
				}
			});
		
		return label;  
	 }
	 
	private _getConsultationLabel(c:any) {
       // console.log('_getConsultationLabe c',c);
		let lbs:any[]=[];
		lbs.push(c.type.libelle);
      //  console.log('_getConsultationLabel lbs',lbs);
      //  console.log('_getConsultationLabel test',moment.parseZone(c.date_debut));
	    let begin= moment.parseZone(c.date_debut) 
        if (begin!=undefined && begin 
        && begin instanceof moment
        )
		    lbs.push("Du "+begin.format("DD/MM/YYYY HH:mm"));
		let end= moment.parseZone(c.date_fin) 
    
            
        if (end!=undefined && end 
        && end instanceof moment
        ) 
		    lbs.push("Au "+end.format("DD/MM/YYYY HH:mm"));
       
             
        if (c.lieu!=undefined
        && c.lieu.NOM!=undefined
        )
		    lbs.push(c.lieu.NOM);  
            
	    if (c.etat!=undefined
			        && c.etat.libelle!=undefined
			        )
				lbs.push("("+c.etat.libelle+")");    
		   
        if (c.lieu!=undefined
        && c.lieu.adresses!=undefined &&
        c.lieu.adresses.PRINCIPALE && c.lieu.adresses.PRINCIPALE.town)
			lbs.push(", "+c.lieu.adresses.PRINCIPALE.town);
 
			
        if (c.professionels!=undefined 
        && c.professionels 
        && c.professionels.length>0) {
            lbs.push(":");
            for(let i:number=0;i<c.professionels.length;i++) {
                let pro:any=c.professionels[i];
                lbs.push(pro.NOM+" "+pro.PRENOM);
            }
        } 
           
                 
		return lbs.join(" ");
	 }
	 
	 openCreateConsultationDialog(event:any) {
    	this._defaultConsultValue=null;
        let _opt = {"visiteType": this.visiteType == "" ? "consultation" : this.visiteType};
		//console.log("VisiteActionsDialog openCreateConsultationDialog",_opt);
		           
    	 this.consultationService.getConsultationTypeList(_opt).subscribe((res: JSONRpcResponse) => {
            res.result.forEach(aff => {
                if(!aff.noDisplay){
                    this.consultationListInPresences.push(aff);
                }
            });
        //    console.log("creationConsultation res:",res);
            let dataCs={
                action: "create",
                dataType: "consultation",
                code: 'CREATE_CONSULT',
                /*dossier: this.dossier,*/
                title: "Création d'une séance",
                create: true,
                types:this.consultationListInPresences,
                updateOnCreate: false,
            }
            
           this.dialogService.open(CreateConsultationDialogComponent, {
                    data: dataCs,
                    height: "90vh",
		            width: "80vw",
                    draggable: true,
                    maximizable: true,
                    minimizable: true,
                    resizable: true,
                }, (res: JSONRpcResponse) => {
                   
                   /*
	                    let _refresh={
							type: "consultation",
							data:res
						};
	                   */
			//		  console.log("created Consultation",res)
					  if (res.result) {
						  	this._defaultConsultValue=res.result;
						  	this.initConsultationsList();
						  
					  }
	                    //this.stateService.updateRefresh(_refresh)
                    
                })
           
        })
	}
	
	filterConsultation(event:any) {
		this.filterListConsult=!this.filterListConsult;
		this.changeDetectorRef.detectChanges();
	}
	
	displayDomicile(tiers?: any){
        if (!tiers) {
          return undefined;
        }
      
        let nom = tiers.NOM ? tiers.NOM : '';
        let prenom = tiers.PRENOM ? tiers.PRENOM : '';
        let adresse = tiers.adresses.PRINCIPALE ? tiers.adresses.PRINCIPALE.address_complete : 'Pas d\'adresse';
      
        return nom + ' ' + prenom + ' - ' + adresse;
    }
	
	_groupSearchList() {
		    let grs:any=[];
		    let lieux:any={
				group:"Ce lieu",
				tiers:[]
			};
			let islieu:boolean=false;
			
			let autres:any={
				group:"Autres",
				tiers:[]
			};
			let isautres:boolean=false;
			
			this.tiersSearchGroupList=[];
			
			for(let i=0;i<this.tiersSearchList.length;i++) {
				if (this.tiersSearchList[i].location) {
				   lieux.tiers.push(this.tiersSearchList[i]);
				   islieu=true;
				}
				else {
					autres.tiers.push(this.tiersSearchList[i]);
					isautres=true;
				}
			}
			if (islieu)
				this.tiersSearchGroupList.push(lieux);
			if (isautres)
				this.tiersSearchGroupList.push(autres);
			//console.log("groupSearchList",this.tiersSearchGroupList);
	}

	formatTime(time: any): string {
		return this.datePipe.transform(time, 'HH:mm');
	}
	

	timeSlotSelected(timeSlot){
		//console.log("___event",timeSlot);
		if(timeSlot && timeSlot.debut){
			if(timeSlot.disponible)
				this.timeChange(this.formatTime(timeSlot.debut), 'debut');
			else{
				this.dialogService.open(ConfirmComponent, {
                    data: {
						libelle: "Ce créneau est déjà pris, êtes vous-sur de choisir cet horaire ?"
					}
                }, (res: any) => {
					if (res === 'true') {
						this.timeChange(this.formatTime(timeSlot.debut), 'debut');
					}
                })
			}
		}
	}

	setUserAsProfessional(){
		if(this.user != undefined && this.user){
			const userInListIdx = this.tiersSearchList.findIndex(tiers=>tiers.tiers.ID == this.user.ID)
			if(userInListIdx !== -1){
				this.selectedTiers.push(this.tiersSearchList[userInListIdx].tiers);
			}
		}
	}

	updateSliderObjEdit(event){
	//	console.log("___consultObjInit before",event,this.selectedConsultation,this.visiteType);
		if(this.selectedConsultation != undefined || this.visiteType == "domicile" || this.visiteType == "ponctuel"){
			let visitesTemp:any[] = [];
			let ifs:any;
			var opt:any = {
						datestring:true,
							/*interval: this.durationInput,
									tiers: res.ID*/
								}
			if(this.setTiersSelected.length >0){
				let atmp:any[] = [];
				this.setTiersSelected.forEach((res) =>{
					opt["interval"]=this.durationInput;
					opt["tiers"]=res.ID;				
					ifs=this.getInfosCurrentVisite(opt);
					
					//let dtd:any=Object.assign({}, ifs);
					//atmp.push(ifs);
					visitesTemp.push(ifs);
				});
				//visitesTemp=JSON.parse(JSON.stringify(atmp));
			}
			else{
				ifs=this.getInfosCurrentVisite(opt);
				let atmp:any[] = [];
				
				//let dtd:any=Object.assign({}, ifs);
				//atmp.push(ifs);
				//visitesTemp=JSON.parse(JSON.stringify(atmp));
				visitesTemp.push(ifs);
			}
			//let tbl:any[]=JSON.parse(JSON.stringify(visitesTemp));
		//	console.log("___consultObjInit",event,ifs,visitesTemp,visitesTemp[0]);
			this.consultModif.next({obj: {editType: "visite",visitesTemp:visitesTemp}, event: event, type: "rdv"});
		}
	}

	locationChange(event){
		this.locationInput = event;
		this.updateSliderObjEdit("location");
	}

	selectDomicile(event){
		this.updateSliderObjEdit("domicile");
	}
	
	formaterDate(element: any,element2? :any){
	    let date = formatDate(element.substring(0,10),"dd/MM/yyyy","fr");
	    let heureMinute = element.substring(11,16);
	    let resultat = date;
		if (element2!=undefined) {
			let heureMinuteFin = element2.substring(11,16);
			resultat+=" - "+heureMinuteFin;
		}
		
		resultat='<div class="d-none">'+element+'</div><span>'+resultat+'</span>';
	    return resultat;
	}
	

	 
}
